/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Monthly_Challenge_Description_DoneInputs */

const en_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You did it! Claim your plant now!`)
};

const ar_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لقد فعلتها! احصل على نبتتك الآن!`)
};

const de_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du hast es geschafft! Hol dir jetzt deine Pflanze!`)
};

const es_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Lo lograste! ¡Reclama tu planta ahora!`)
};

const fr_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous avez réussi ! Récupérez votre plante maintenant !`)
};

const it_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce l'hai fatta! Riscatta la tua pianta adesso!`)
};

const ja_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`やりましたね！今すぐ植物を受け取りましょう！`)
};

const ko_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해내셨군요! 지금 식물을 받으세요!`)
};

const pt_br_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você conseguiu! Resgate sua planta agora!`)
};

const ru_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас получилось! Заберите свое растение прямо сейчас!`)
};

const th_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณทำได้แล้ว! รับต้นไม้ของคุณตอนนี้เลย!`)
};

const tr_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başardın! Bitkini şimdi al!`)
};

const zh_cn_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挑战达成！快领取你的植物吧！`)
};

const zh_tw_monthly_challenge_description_done = /** @type {(inputs: Monthly_Challenge_Description_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`挑戰達成！快領取你的植物吧！`)
};

/**
* | output |
* | --- |
* | "You did it! Claim your plant now!" |
*
* @param {Monthly_Challenge_Description_DoneInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const monthly_challenge_description_done = /** @type {((inputs?: Monthly_Challenge_Description_DoneInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Monthly_Challenge_Description_DoneInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_monthly_challenge_description_done(inputs)
	if (locale === "ar") return ar_monthly_challenge_description_done(inputs)
	if (locale === "de") return de_monthly_challenge_description_done(inputs)
	if (locale === "es") return es_monthly_challenge_description_done(inputs)
	if (locale === "fr") return fr_monthly_challenge_description_done(inputs)
	if (locale === "it") return it_monthly_challenge_description_done(inputs)
	if (locale === "ja") return ja_monthly_challenge_description_done(inputs)
	if (locale === "ko") return ko_monthly_challenge_description_done(inputs)
	if (locale === "pt_br") return pt_br_monthly_challenge_description_done(inputs)
	if (locale === "ru") return ru_monthly_challenge_description_done(inputs)
	if (locale === "th") return th_monthly_challenge_description_done(inputs)
	if (locale === "tr") return tr_monthly_challenge_description_done(inputs)
	if (locale === "zh_cn") return zh_cn_monthly_challenge_description_done(inputs)
	return zh_tw_monthly_challenge_description_done(inputs)
});